module.exports = __webpack_public_path__ + "img/Icon ionic-ios-search-blue.c70c6a47.svg";